import axios from "axios";
import React, { useState, useEffect, useRef } from 'react';
import { MDBCard, MDBCardBody, MDBBtn, MDBRow, MDBCol, MDBAlert, MDBIcon, MDBCheckbox, MDBSpinner } from 'mdb-react-ui-kit';
import logo from "./../components/images/Easy-MembrLogo.png";
import { getWaiverSettings, createWaiver, logEvent, getPricingPlansById, getMemeberProfile, createMultiWaiverForms, verifyWaiverOtp, resendWaiverVerification } from "../services/apiServices.js";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from 'react-router';
import { isEmail, isEmpty } from '../validators/helper';
import { CountryDropdown } from "react-country-region-selector";
import SuccessScreen from "../components/sucessScreen.js";
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { browserName, browserVersion } from "react-device-detect";
import SignatureCanvas from 'react-signature-canvas';
import { formatWaiverDate } from '../utils/DateFormat';
import UploadMemberImg from "./uploadMemberImg";
import { slugToId } from "../utils/slug";
import { useAnalytics } from "../hooks/useAnalytics";
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DigitalWaiver() {
    const { trackButtonClick } = useAnalytics();
    function decryptId(encryptedId) {
        return atob(encryptedId);
    }
    const sigCanvas = useRef(null);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const encryptedGymId = params.get('id') ? params.get('id') : "";
    let userEventGymURL = params.get('mId') ? params.get('mId') : "";
    const memberid = slugToId(userEventGymURL);
    const decryptedUID = decryptId(encryptedGymId);
    let uniqueID = decryptedUID;

    const [signatureDone, setSignatureDone] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState({});
    const [merror, setmerror] = useState([]);
    const [noError, setNoError] = useState(false);
    const [submitDisable, setSubmitDisable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [PlanInfo, setPlanInfo] = useState(null);
    const [pdfFileLink, setPdfFileLink] = useState('');
    const [logourl, setLogourl] = useState(logo);
    const [imageLoaded, setImageLoaded] = useState(true);
    const navigate = useNavigate();
    const [Error2, setError2] = useState("");
    const [awaitingVerification, setAwaitingVerification] = useState(null);
    const [verifyOtpInput, setVerifyOtpInput] = useState("");
    const [verifyBusy, setVerifyBusy] = useState(false);
    const [checkboxesState, setCheckboxesState] = useState({});

    const [participants, setParticipants] = useState([
        {
            id: Date.now(),
            fname: "",
            lname: "",
            dateofbirth: "",
            gender: "",
            phone: "",
            email: "",
            confirmEmail: "",
            street: "",
            area: "",
            city: "",
            country: "",
            bloodgroup: "",
            imgurl: "",
            age: null,
            isMinor: false,
            pincode: "",
            governmentIdType: "",
            governmentIdNumber: ""
        }
    ]);

    const [guardian, setGuardian] = useState({
        consultingadultfirstname: "",
        consultingadultlastname: "",
        consultingadultcontact: "",
        consultingadultrelation: ""
    });

    const [emergency, setEmergency] = useState({
        emergencyfirstname: "",
        emergencylastname: "",
        emergencycontact: "",
        emergencyrelation: ""
    });

    const [formMeta, setFormMeta] = useState({
        mId: memberid,
        checkBox: false,
        signature: "",
        ipAddress: "",
        gymid: "",
        agreementDate: null
    });

    const allbloodgroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
    const genderOptions = ["Male", "Female", "Other"];
    const countryOptions = ["India", "USA", "UK", "Canada", "Australia"];

    useEffect(() => {
        if (data && data.checkboxes && Array.isArray(data.checkboxes)) {
            const initialCheckboxState = {};
            data.checkboxes.forEach((checkbox, index) => {
                initialCheckboxState[checkbox.id] = false;
            });
            setCheckboxesState(initialCheckboxState);
        }
    }, [data]);

    useEffect(() => {
        async function fetchMemberData() {
            const response = await getMemeberProfile(memberid);
            if (!response || response === "false") return;
            const record = await response.json();
            if (!record) return;

            setParticipants([{
                id: Date.now(),
                fname: record.fname || "",
                lname: record.lname || "",
                phone: record.number || "",
                email: record.email || "",
                confirmEmail: record.email || "",
                dateofbirth: record.dateofbirth || "",
                gender: record.gender || "",
                bloodgroup: record.bloodgroup || "",
                street: record.street || "",
                area: record.area || "",
                city: record.city || "",
                country: record.country || "",
                imgurl: record.imgurl || "",
                pincode: record.pincode || "",
                age: record.dateofbirth ? calculateAge(record.dateofbirth) : null,
                isMinor: record.dateofbirth ? calculateAge(record.dateofbirth) < 18 : false,
                governmentIdType: "",
                governmentIdNumber: ""
            }]);
        }
        fetchMemberData();
    }, [memberid]);

    useEffect(() => {
        async function fetchData() {
            const response = await getWaiverSettings(uniqueID);
            if (!response || response === 'false') return;
            const recinfo = await response.json();
            console.log(recinfo, 'recinfo');

            if (recinfo.gymid) {
                setData(recinfo);
                setFormMeta(prev => ({ ...prev, gymid: recinfo.gymid }));
                setLogourl(recinfo.gymInfo?.logourl || logo);
            } else {
                setError2("Link has been expired. Please contact admin.");
            }
        }
        fetchData();
    }, [uniqueID]);

    useEffect(() => {
        if (!formMeta.ipAddress && formMeta.gymid) {
            setIpAddress();
        }

        if (data && data.checkboxes && Array.isArray(data.checkboxes)) {
            const allRequiredChecked = data.checkboxes.every(checkbox => {
                if (checkbox.required) {
                    return checkboxesState[checkbox.id] === true;
                }
                return true;
            });
            setSubmitDisable(!allRequiredChecked);
        }
    }, [formMeta, data, checkboxesState]);

    const frontEndEnvData = localStorage.getItem("frontEndEnvData");
    const googleMapsApiKeydata = frontEndEnvData ? JSON.parse(frontEndEnvData)?.reactappipaddressurl : "https://api.ipify.org?format=json";

    async function setIpAddress() {
        try {
            const url = googleMapsApiKeydata;
            const res = await axios.get(url);
            setFormMeta(prev => ({ ...prev, ipAddress: res.data.ip }));
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        const getPricingPlansBYGymid = async () => {
            if (!formMeta.gymid) {
                setPlanInfo(null);
                return;
            }
            const response = await getPricingPlansById(formMeta.gymid);
            if (!response || response === "false") return;
            const recinfo = await response.json();
            setPlanInfo(recinfo?.feature ? recinfo : null);
        }
        getPricingPlansBYGymid();
    }, [formMeta.gymid]);

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    const calculateAge = (dob) => {
        if (!dob) return null;
        const birth = dob instanceof Date ? dob : new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const m = today.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };

    const updateParticipant = (index, field, value) => {
        setParticipants(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };

            if (field === 'dateofbirth') {
                if (isValidDate(value)) {
                    const year = value.getFullYear();
                    const month = String(value.getMonth() + 1).padStart(2, '0');
                    const day = String(value.getDate()).padStart(2, '0');
                    const iso = `${year}-${month}-${day}`;
                    updated[index].dateofbirth = iso;
                    const age = calculateAge(value);
                    updated[index].age = age;
                    updated[index].isMinor = age < 18;
                    if (index > 0 && age < 18 && !guardian.consultingadultfirstname) {
                        const firstParticipant = updated[0];
                        setGuardian({
                            consultingadultfirstname: firstParticipant?.fname || "",
                            consultingadultlastname: firstParticipant?.lname || "",
                            consultingadultcontact: firstParticipant?.phone || "",
                            consultingadultrelation: "Parent"
                        });
                    }
                } else {
                    updated[index].dateofbirth = "";
                    updated[index].age = null;
                    updated[index].isMinor = false;
                }
            }

            // Clear government ID errors when fields change
            if (field === 'governmentIdType' || field === 'governmentIdNumber') {
                if (error[`p${index}_governmentIdType`]) {
                    setError(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[`p${index}_governmentIdType`];
                        return newErrors;
                    });
                }
                if (error[`p${index}_governmentIdNumber`]) {
                    setError(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[`p${index}_governmentIdNumber`];
                        return newErrors;
                    });
                }
            }

            // Clear email-related errors when either email or confirmEmail changes
            if (field === 'email' || field === 'confirmEmail') {
                if (error[`p${index}_email`]) {
                    setError(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[`p${index}_email`];
                        return newErrors;
                    });
                }
                if (error[`p${index}_confirmEmail`]) {
                    setError(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[`p${index}_confirmEmail`];
                        return newErrors;
                    });
                }
            }

            if (error[`p${index}_${field}`]) {
                setError(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[`p${index}_${field}`];
                    return newErrors;
                });
            }

            return updated;
        });
    };

    const addParticipant = () => {
        setParticipants(prev => [
            ...prev,
            {
                id: Date.now(),
                fname: "",
                lname: "",
                dateofbirth: "",
                gender: "",
                phone: "",
                email: "",
                confirmEmail: "",
                street: "",
                area: "",
                city: "",
                country: "",
                bloodgroup: "",
                imgurl: "",
                age: null,
                isMinor: false,
                pincode: "",
                governmentIdType: "",
                governmentIdNumber: ""
            }
        ]);
    };

    const removeParticipant = (index) => {
        if (participants.length > 1) {
            const newErrors = { ...error };
            Object.keys(newErrors).forEach(key => {
                if (key.startsWith(`p${index}_`)) {
                    delete newErrors[key];
                }
            });
            setError(newErrors);
            setParticipants(prev => prev.filter((_, i) => i !== index));
        }
    };

    const hasMinor = participants.some(p => p.isMinor === true);

    const handleCheckboxToggle = (checkboxId) => {
        setCheckboxesState(prev => ({
            ...prev,
            [checkboxId]: !prev[checkboxId]
        }));

        if (error.checkboxes) {
            setError(prev => {
                const newErrors = { ...prev };
                delete newErrors.checkboxes;
                return newErrors;
            });
        }
    };

    const isAlphabetical = (str) => /^[a-zA-Z\s]+$/.test(str);

    const validateForm = (e) => {
        e.preventDefault();
        let errors = {};
        let errorSections = [];

        if (data && data.checkboxes && Array.isArray(data.checkboxes)) {
            const requiredUnchecked = data.checkboxes.filter(checkbox =>
                checkbox.required && !checkboxesState[checkbox.id]
            );

            if (requiredUnchecked.length > 0) {
                errors.checkboxes = `Please check all required checkboxes`;
                errorSections.push("Agreement Checkboxes");
            }
        }

        participants.forEach((p, idx) => {
            const prefix = `p${idx}_`;
            let hasParticipantError = false;

            if (isEmpty(p.fname)) {
                errors[`${prefix}fname`] = "Field can't be empty.";
                hasParticipantError = true;
            } else if (!isAlphabetical(p.fname)) {
                errors[`${prefix}fname`] = "Name can be only alphabetic characters";
                hasParticipantError = true;
            }

            if (isEmpty(p.lname)) {
                errors[`${prefix}lname`] = "Field can't be empty.";
                hasParticipantError = true;
            } else if (!isAlphabetical(p.lname)) {
                errors[`${prefix}lname`] = "Name can be only alphabetic characters";
                hasParticipantError = true;
            }

            if (!p?.dateofbirth) {
                errors[`${prefix}dateofbirth`] = "Field can't be empty.";
                hasParticipantError = true;
            } else if (isNaN(new Date(p.dateofbirth))) {
                errors[`${prefix}dateofbirth`] = "Please select a valid date";
                hasParticipantError = true;
            } else if (idx > 0) {
                const age = calculateAge(new Date(p.dateofbirth));
                if (age >= 18) {
                    errors[`${prefix}dateofbirth`] = "Additional participants must be under 18 years of age";
                    hasParticipantError = true;
                }
            }

            if (isEmpty(p.gender)) {
                errors[`${prefix}gender`] = "Please select gender";
                hasParticipantError = true;
            }

            if (data?.bloodgroup === 1) {
                if (isEmpty(p.bloodgroup)) {
                    errors[`${prefix}bloodgroup`] = "Please select blood group";
                    hasParticipantError = true;
                }
            } else if (data?.bloodgroup === 2) {
                if (!isEmpty(p.bloodgroup) && !allbloodgroups.includes(p.bloodgroup)) {
                    errors[`${prefix}bloodgroup`] = "Please select a valid blood group";
                    hasParticipantError = true;
                }
            }

            if (data?.pincode === 1) {
                if (isEmpty(p.pincode)) {
                    errors[`${prefix}pincode`] = "Please enter pincode";
                    hasParticipantError = true;
                }
            } else if (data?.pincode === 2) {
                if (!isEmpty(p.pincode) && !/^\d{6}$/.test(p.pincode)) {
                    errors[`${prefix}pincode`] = "Please enter a valid 6-digit pincode";
                    hasParticipantError = true;
                }
            }

            // Email validation with confirm email
            if (data?.email !== 3) {
                const isEmailRequired = data?.email === 1;

                if (isEmailRequired && isEmpty(p.email)) {
                    errors[`${prefix}email`] = "Field can't be empty.";
                    hasParticipantError = true;
                } else if (!isEmpty(p.email) && !isEmail(p.email)) {
                    errors[`${prefix}email`] = "Please enter valid email address";
                    hasParticipantError = true;
                }

                // Confirm Email Validation
                if (isEmailRequired || (!isEmpty(p.email) && data?.email === 2)) {
                    if (isEmpty(p.confirmEmail)) {
                        errors[`${prefix}confirmEmail`] = "Please confirm your email";
                        hasParticipantError = true;
                    } else if (p.email !== p.confirmEmail) {
                        errors[`${prefix}confirmEmail`] = "Email addresses do not match";
                        hasParticipantError = true;
                    }
                }
            }

            if (data?.phone === 1) {
                if (isEmpty(p.phone)) {
                    errors[`${prefix}phone`] = "Field can't be empty.";
                    hasParticipantError = true;
                } else if (!isValidPhoneNumber(p.phone)) {
                    errors[`${prefix}phone`] = "Please enter valid Phone Number";
                    hasParticipantError = true;
                }
            } else if (data?.phone === 2) {
                if (!isEmpty(p.phone) && !isValidPhoneNumber(p.phone)) {
                    errors[`${prefix}phone`] = "Please enter valid Phone Number";
                    hasParticipantError = true;
                }
            }

            // Government ID Validation based on governmentidproof setting
            if (data?.governmentidproof && data?.governmentIds && Array.isArray(data.governmentIds) && data.governmentIds.length > 0) {
                if (data.governmentidproof === 1) {
                    // Mandatory - user must select ID type AND enter ID number
                    if (isEmpty(p.governmentIdType)) {
                        errors[`${prefix}governmentIdType`] = "Please select government ID type";
                        hasParticipantError = true;
                    }
                    if (isEmpty(p.governmentIdNumber)) {
                        errors[`${prefix}governmentIdNumber`] = `Please enter your ${p.governmentIdType || 'government'} ID number`;
                        hasParticipantError = true;
                    }
                } else if (data.governmentidproof === 2) {
                    // Optional - if user selects ID type, they must enter number
                    if (p.governmentIdType && !p.governmentIdNumber) {
                        errors[`${prefix}governmentIdNumber`] = `Please enter your ${p.governmentIdType} number`;
                        hasParticipantError = true;
                    }
                    if (p.governmentIdNumber && !p.governmentIdType) {
                        errors[`${prefix}governmentIdType`] = "Please select ID type";
                        hasParticipantError = true;
                    }
                }
                // If governmentidproof === 3, exclude - don't show the field at all
            }

            if (data?.address === 1) {
                if (isEmpty(p.street)) {
                    errors[`${prefix}street`] = "Field can't be empty.";
                    hasParticipantError = true;
                }
                if (isEmpty(p.area)) {
                    errors[`${prefix}area`] = "Field can't be empty.";
                    hasParticipantError = true;
                }
                if (isEmpty(p.city)) {
                    errors[`${prefix}city`] = "Field can't be empty.";
                    hasParticipantError = true;
                }
                if (isEmpty(p.country)) {
                    errors[`${prefix}country`] = "Please select country";
                    hasParticipantError = true;
                }
            }

            if (hasParticipantError && !errorSections.includes(`Participant ${idx + 1}`)) {
                errorSections.push(`Participant ${idx + 1}`);
            }
        });

        if (hasMinor) {
            let hasGuardianError = false;
            if (data.consultingcontact === 1) {


                if (isEmpty(guardian.consultingadultfirstname)) {
                    errors.guardian_fname = "Field can't be empty.";
                    hasGuardianError = true;
                } else if (!isAlphabetical(guardian.consultingadultfirstname)) {
                    errors.guardian_fname = "Name can be only alphabetic characters";
                    hasGuardianError = true;
                }

                if (isEmpty(guardian.consultingadultlastname)) {
                    errors.guardian_lname = "Field can't be empty.";
                    hasGuardianError = true;
                } else if (!isAlphabetical(guardian.consultingadultlastname)) {
                    errors.guardian_lname = "Name can be only alphabetic characters";
                    hasGuardianError = true;
                }

                if (isEmpty(guardian.consultingadultcontact)) {
                    errors.guardian_contact = "Field can't be empty.";
                    hasGuardianError = true;
                } else if (!isValidPhoneNumber(guardian.consultingadultcontact)) {
                    errors.guardian_contact = "Please enter valid Phone Number";
                    hasGuardianError = true;
                }

                if (isEmpty(guardian.consultingadultrelation)) {
                    errors.guardian_relation = "Field can't be empty.";
                    hasGuardianError = true;
                } else if (!isAlphabetical(guardian.consultingadultrelation)) {
                    errors.guardian_relation = "Relationship can be only alphabetic characters";
                    hasGuardianError = true;
                }
            }
            if (hasGuardianError) {
                errorSections.push("Parent/Guardian Details");
            }
        }

        if (data?.emergencycontact !== 3) {
            let hasEmergencyError = false;

            if (data?.emergencycontact === 1) {
                if (isEmpty(emergency.emergencyfirstname)) {
                    errors.emergencyfirstname = "Field can't be empty.";
                    hasEmergencyError = true;
                } else if (!isAlphabetical(emergency.emergencyfirstname)) {
                    errors.emergencyfirstname = "Name can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (isEmpty(emergency.emergencylastname)) {
                    errors.emergencylastname = "Field can't be empty.";
                    hasEmergencyError = true;
                } else if (!isAlphabetical(emergency.emergencylastname)) {
                    errors.emergencylastname = "Name can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (isEmpty(emergency.emergencyrelation)) {
                    errors.emergencyrelation = "Field can't be empty.";
                    hasEmergencyError = true;
                } else if (!isAlphabetical(emergency.emergencyrelation)) {
                    errors.emergencyrelation = "Relationship can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (isEmpty(emergency.emergencycontact)) {
                    errors.emergencycontact = "Field can't be empty.";
                    hasEmergencyError = true;
                } else if (!isValidPhoneNumber(emergency.emergencycontact)) {
                    errors.emergencycontact = "Please enter valid Phone Number";
                    hasEmergencyError = true;
                }
            } else if (data?.emergencycontact === 2) {
                if (!isEmpty(emergency.emergencyfirstname) && !isAlphabetical(emergency.emergencyfirstname)) {
                    errors.emergencyfirstname = "Name can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (!isEmpty(emergency.emergencylastname) && !isAlphabetical(emergency.emergencylastname)) {
                    errors.emergencylastname = "Name can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (!isEmpty(emergency.emergencyrelation) && !isAlphabetical(emergency.emergencyrelation)) {
                    errors.emergencyrelation = "Relationship can be only alphabetic characters";
                    hasEmergencyError = true;
                }
                if (!isEmpty(emergency.emergencycontact) && !isValidPhoneNumber(emergency.emergencycontact)) {
                    errors.emergencycontact = "Please enter valid Phone Number";
                    hasEmergencyError = true;
                }
            }

            if (hasEmergencyError) {
                errorSections.push("Emergency Contact");
            }
        }

        if (!signatureDone) {
            errors.signatureDone = "Please sign the form before submitting.";
            if (!errorSections.includes("Signature")) {
                errorSections.push("Signature");
            }
        }

        setError(errors);
        setmerror(errorSections);

        return Object.keys(errors).length === 0;
    };

    const onSubmitForm = async (e) => {
        e.preventDefault();
        const agreementDate = new Date();

        const checkedCheckboxes = data?.checkboxes
            ? data.checkboxes.map(checkbox => ({
                id: checkbox.id,
                text: checkbox.text,
                required: checkbox.required,
                checked: checkboxesState[checkbox.id] || false
            }))
            : [];

        const payload = {
            gymid: formMeta.gymid,
            mId: memberid,
            signature: formMeta.signature,
            ipAddress: formMeta.ipAddress,
            agreementDate,
            agreement: data?.agreement,
            title: data?.title || "Digital waiver Form",
            checkboxes: checkedCheckboxes,
            participants: participants.map(p => ({
                fname: p.fname,
                lname: p.lname,
                dateofbirth: p.dateofbirth,
                gender: p.gender,
                phone: p.phone,
                email: p.email,
                confirmEmail: p.confirmEmail,
                street: p.street,
                area: p.area,
                city: p.city,
                country: p.country,
                bloodgroup: p.bloodgroup,
                imgurl: p.imgurl,
                age: p.age,
                pincode: p.pincode,
                governmentIdType: p.governmentIdType || "",
                governmentIdNumber: p.governmentIdNumber || ""
            })),
            emergency: {
                firstname: emergency.emergencyfirstname,
                lastname: emergency.emergencylastname,
                contact: emergency.emergencycontact,
                relation: emergency.emergencyrelation
            }
        };

        if (hasMinor) {
            payload.guardian = {
                firstname: guardian.consultingadultfirstname,
                lastname: guardian.consultingadultlastname,
                contact: guardian.consultingadultcontact,
                relation: guardian.consultingadultrelation
            };
        }

        try {
            setLoading(true);
            const rec = await createMultiWaiverForms(payload);
            if (!rec || rec === "false") {
                setError2("Something went wrong. Please try again.");
                setLoading(false);
                setSubmitDisable(false);
                return;
            }
            const responseObj = await rec.json();
            if (responseObj.requiresVerification && responseObj.pendingId) {
                setAwaitingVerification({
                    pendingId: responseObj.pendingId,
                    maskedEmail: responseObj.maskedEmail || "",
                });
                setVerifyOtpInput("");
                setLoading(false);
                setSubmitDisable(false);
                return;
            }
            if (responseObj.status) {
                setNoError(true);
                setPdfFileLink(responseObj.pdfFileLink);

                const ip = formMeta.ipAddress;
                const browserinfo = browserName + "-" + browserVersion + ".0.0";
                const flag = `Waiver Form Submitted Successfully (${participants.length} participant(s))`;
                const Eventtype = "Digital Waiver";
                const gymid = formMeta.gymid;
                const username1 = "Digital Waiver Form";

                logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
                trackButtonClick("Digitalwaiver", "Waiver_Submit", "member", {
                    gymid: gymid,
                    gymname: data?.gymInfo?.businessName || "GYM Admin Online",
                    username: participants[0]?.fname + " " + participants[0]?.lname,
                    participantCount: participants.length
                });

                const pendingRedirectUrl = sessionStorage.getItem("pendingRedirectUrl");
                if (pendingRedirectUrl) {
                    setTimeout(() => navigate(pendingRedirectUrl), 2000);
                }
            } else {
                setError2(responseObj.message || responseObj.error || "Something went wrong. Please try again.");
            }
        } catch (err) {
            console.error("Error submitting form:", err);
            setError2("An error occurred. Please try again.");
        } finally {
            setLoading(false);
            setSubmitDisable(false);
        }
    };

    const submitHandler = (e) => {
        e.preventDefault();
        if (!navigator.onLine) {
            setError2("No Internet Connection. Please check your internet connection and try again.");
            return;
        }
        if (validateForm(e)) {
            onSubmitForm(e);
        }
    };

    const submitVerificationOtp = async () => {
        if (!awaitingVerification?.pendingId || !verifyOtpInput.trim()) {
            setError2("Enter the 6-digit code from your email.");
            return;
        }
        setVerifyBusy(true);
        setError2("");
        try {
            const rec = await verifyWaiverOtp({
                pendingId: awaitingVerification.pendingId,
                otp: verifyOtpInput.trim(),
            });
            if (!rec || rec === "false") {
                setError2("Verification failed. Please try again.");
                setVerifyBusy(false);
                return;
            }
            const data = await rec.json();
            if (data.status) {
                const pdf =
                    data.pdfFileLink ||
                    (Array.isArray(data.pdfFileLinks) && data.pdfFileLinks[0]) ||
                    "";
                setPdfFileLink(pdf);
                setAwaitingVerification(null);
                setNoError(true);
                const ip = formMeta.ipAddress;
                const browserinfo = browserName + "-" + browserVersion + ".0.0";
                const flag = `Waiver Form Submitted Successfully (${participants.length} participant(s))`;
                const Eventtype = "Digital Waiver";
                const gymid = formMeta.gymid;
                const username1 = "Digital Waiver Form";
                logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
                trackButtonClick("Digitalwaiver", "Waiver_Verify_Otp", "member", {
                    gymid: gymid,
                    gymname: data?.gymInfo?.businessName || "GYM Admin Online",
                });
                const pendingRedirectUrl = sessionStorage.getItem("pendingRedirectUrl");
                if (pendingRedirectUrl) {
                    setTimeout(() => navigate(pendingRedirectUrl), 2000);
                }
            } else {
                setError2(data.message || "Invalid code. Please try again.");
            }
        } catch (err) {
            console.error(err);
            setError2("Verification failed. Please try again.");
        }
        setVerifyBusy(false);
    };

    const resendVerificationEmail = async () => {
        if (!awaitingVerification?.pendingId) return;
        setVerifyBusy(true);
        setError2("");
        try {
            const rec = await resendWaiverVerification({ pendingId: awaitingVerification.pendingId });
            if (!rec || rec === "false") {
                setError2("Could not resend email.");
                setVerifyBusy(false);
                return;
            }
            const data = await rec.json();
            if (data.status) {
                setError2("");
                alert("A new verification email has been sent.");
            } else {
                setError2(data.message || "Could not resend.");
            }
        } catch (e) {
            setError2("Could not resend email.");
        }
        setVerifyBusy(false);
    };

    const handleSignatureClear = () => {
        sigCanvas.current.clear();
        setSignatureDone(false);
        setFormMeta(prev => ({ ...prev, signature: "" }));

        if (error.signatureDone) {
            setError(prev => {
                const newErrors = { ...prev };
                delete newErrors.signatureDone;
                return newErrors;
            });
        }
    };

    const handleSignatureChange = () => {
        const signatureData = sigCanvas.current;
        if (signatureData.isEmpty()) {
            setSignatureDone(false);
        } else {
            setSignatureDone(true);
            const signatureBase64 = sigCanvas.current.toDataURL();
            setFormMeta(prev => ({ ...prev, signature: signatureBase64 }));

            if (error.signatureDone) {
                setError(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.signatureDone;
                    return newErrors;
                });
            }
        }
    };

    useEffect(() => {
        const resizeCanvas = () => {
            if (sigCanvas.current) {
                const canvas = sigCanvas.current.getCanvas();
                canvas.width = canvas.offsetWidth;
                canvas.height = canvas.offsetHeight;
            }
        };
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();
        return () => window.removeEventListener('resize', resizeCanvas);
    }, []);

    useEffect(() => {
        const handleImageLoad = () => setImageLoaded(true);
        const handleImageError = () => setImageLoaded(false);
        const imgElement = new Image();
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = logourl;
        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [logourl]);

    return (
        <React.Fragment>
            <div className="h-100vhWave">
                <MDBCard className='waveForm'>
                    <MDBCardBody className='py-3 position-relative'>
                        <div className="mobile-Head">
                            <div className='d-flex align-items-center Waiver-logo'>
                                <div className='d-flex align-items-center '>
                                    <img src={imageLoaded ? logourl : logo} className="w-20 mob-w-40" alt="logo" />
                                    <div className='d-flex align-items-start flex-column mt-2 border-start ps-2 border-2'>
                                        <h5 className='logoColor'>
                                            {data?.gymInfo?.businessName || "GYM Admin Online"}
                                        </h5>
                                        <div className='d-flex'>
                                            <p className='m-0'>
                                                {data?.gymInfo ? (
                                                    (data.gymInfo.address ? data.gymInfo.address : '') +
                                                    ((data.gymInfo.address && data.gymInfo.city) ? ', ' : '') +
                                                    (data.gymInfo.city ? data.gymInfo.city : '')
                                                ) : "Sundarayya Vignana Kendram, Gachibowli, Hyderabad"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="routing-border"></div>
                        </div>

                        <div className='text-center mt-2 mb-2'>
                            <h5 className='text-dark m-0'>{data?.title || "Digital Waiver Form"}</h5>
                        </div>

                        {noError ? (
                            <SuccessScreen pdfFileLink={pdfFileLink} />
                        ) : awaitingVerification ? (
                            <div className="px-2 py-4 text-center">
                                <h5 className="mb-2">Verify your email</h5>
                                <p className="text-muted">
                                    We sent a 6-digit code to <strong>{awaitingVerification.maskedEmail}</strong>.
                                    You can also use the &quot;Agree &amp; Verify&quot; button in that email.
                                </p>
                                <div className="d-flex flex-column align-items-center gap-2 mt-3">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={6}
                                        className="form-control text-center"
                                        style={{ maxWidth: "200px", letterSpacing: "0.3em", fontSize: "1.25rem" }}
                                        placeholder="000000"
                                        value={verifyOtpInput}
                                        onChange={(e) => setVerifyOtpInput(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                    />
                                    <MDBBtn
                                        className="mt-2"
                                        disabled={verifyBusy}
                                        onClick={() => submitVerificationOtp()}
                                    >
                                        {verifyBusy ? <MDBSpinner size="sm" /> : "Confirm"}
                                    </MDBBtn>
                                    <MDBBtn color="link" size="sm" disabled={verifyBusy} onClick={() => resendVerificationEmail()}>
                                        Resend email
                                    </MDBBtn>
                                </div>
                                {Error2 && <p className="text-danger small mt-2">{Error2}</p>}
                            </div>
                        ) : (
                            <>
                                {participants.map((participant, index) => (
                                    <React.Fragment key={participant.id || index}>
                                        <MDBRow>
                                            {participants.length > 1 && (
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <h6 className="text-primary mb-0">Participant {index + 1}</h6>
                                                    {index > 0 && (
                                                        <MDBBtn
                                                            disableAutoFocus
                                                            color="link"
                                                            className="p-0 text-danger"
                                                            onClick={() => removeParticipant(index)}
                                                        >
                                                            <MDBIcon fas icon="trash-alt" /> Remove
                                                        </MDBBtn>
                                                    )}
                                                </div>)}

                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers w-100 mt-2">
                                                    <strong>First Name<span className="text-danger">*</span></strong>
                                                </div>
                                                <div className="pt-1 w-100">
                                                    <input
                                                        placeholder='Enter first name'
                                                        type="text"
                                                        className="w-100 form-control"
                                                        onChange={(e) => updateParticipant(index, 'fname', e.target.value)}
                                                        value={participant.fname}
                                                    />
                                                    {error[`p${index}_fname`] && (
                                                        <span className="clr-red waiver-error-txt">{error[`p${index}_fname`]}</span>
                                                    )}
                                                </div>
                                            </MDBCol>

                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers w-100 mt-2">
                                                    <strong>Last Name<span className="text-danger">*</span></strong>
                                                </div>
                                                <div className="pt-1 w-100">
                                                    <input
                                                        placeholder='Enter last name'
                                                        type="text"
                                                        className="w-100 form-control"
                                                        onChange={(e) => updateParticipant(index, 'lname', e.target.value)}
                                                        value={participant.lname}
                                                    />
                                                    {error[`p${index}_lname`] && (
                                                        <span className="clr-red waiver-error-txt">{error[`p${index}_lname`]}</span>
                                                    )}
                                                </div>
                                            </MDBCol>

                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Date of Birth<span className="text-danger">*</span></strong>
                                                </div>
                                                <div className="form pt-1 w-100">
                                                    <DatePicker
                                                        selected={participant.dateofbirth ? new Date(participant.dateofbirth.slice(0, 10) + "T00:00:00") : null}
                                                        onChange={(date) => updateParticipant(index, 'dateofbirth', date)}
                                                        dateFormat="yyyy-MM-dd"
                                                        minDate={
                                                            index > 0
                                                                ? new Date(new Date().setFullYear(new Date().getFullYear() - 18))
                                                                : null
                                                        }
                                                        maxDate={new Date()}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="Select DOB"
                                                        className="form-control"
                                                    />
                                                </div>
                                                {error[`p${index}_dateofbirth`] && (
                                                    <span className="clr-red waiver-error-txt">{error[`p${index}_dateofbirth`]}</span>
                                                )}
                                            </MDBCol>

                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Gender<span className="text-danger">*</span></strong>
                                                </div>
                                                <select
                                                    className='form-select'
                                                    onChange={(e) => updateParticipant(index, 'gender', e.target.value)}
                                                    value={participant.gender}
                                                >
                                                    <option value="" disabled>Select Gender</option>
                                                    {genderOptions.map((option) => (
                                                        <option key={option} value={option}>{option}</option>
                                                    ))}
                                                </select>
                                                {error[`p${index}_gender`] && (
                                                    <span className="clr-red waiver-error-txt">{error[`p${index}_gender`]}</span>
                                                )}
                                            </MDBCol>

                                            {data?.bloodgroup !== 3 && (
                                                <MDBCol sm={12} md={4}>
                                                    <div className="tel-numbers mt-2">
                                                        <strong>Blood Group{data?.bloodgroup === 1 && <span className="text-danger">*</span>}</strong>
                                                    </div>
                                                    <select
                                                        className='form-select p-1 ps-2 mt-1'
                                                        onChange={(e) => updateParticipant(index, 'bloodgroup', e.target.value)}
                                                        value={participant.bloodgroup}
                                                    >
                                                        <option value="" disabled>Select</option>
                                                        {allbloodgroups.map((group) => (
                                                            <option key={group} value={group}>{group}</option>
                                                        ))}
                                                    </select>
                                                    {error[`p${index}_bloodgroup`] && (
                                                        <span className="clr-red waiver-error-txt">{error[`p${index}_bloodgroup`]}</span>
                                                    )}
                                                </MDBCol>
                                            )}

                                            {data?.phone !== 3 && (
                                                <MDBCol sm={12} md={4}>
                                                    <div className="tel-numbers mt-2 w-100">
                                                        <strong>Phone Number{data?.phone === 1 && <span className="text-danger">*</span>}</strong>
                                                    </div>
                                                    <div className="form pt-1 w-100">
                                                        <PhoneInput
                                                            className="form-control d-flex"
                                                            defaultCountry="IN"
                                                            placeholder="Enter phone number"
                                                            value={participant.phone}
                                                            onChange={(value) => updateParticipant(index, 'phone', value)}
                                                        />
                                                    </div>
                                                    {error[`p${index}_phone`] && (
                                                        <span className="clr-red waiver-error-txt">{error[`p${index}_phone`]}</span>
                                                    )}
                                                </MDBCol>
                                            )}

                                            {data?.email !== 3 && (
                                                <>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2 w-100">
                                                            <strong>Email{data?.email === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <div className="form pt-1 w-100">
                                                            <input
                                                                placeholder='example@gmail.com'
                                                                type="email"
                                                                className="w-100 form-control"
                                                                onChange={(e) => updateParticipant(index, 'email', e.target.value)}
                                                                value={participant.email}
                                                            />
                                                        </div>
                                                        {error[`p${index}_email`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_email`]}</span>
                                                        )}
                                                    </MDBCol>

                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2 w-100">
                                                            <strong>Confirm Email{data?.email === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <div className="form pt-1 w-100">
                                                            <input
                                                                placeholder='Confirm email address'
                                                                type="email"
                                                                className="w-100 form-control"
                                                                onChange={(e) => updateParticipant(index, 'confirmEmail', e.target.value)}
                                                                value={participant.confirmEmail}
                                                            />
                                                        </div>
                                                        {error[`p${index}_confirmEmail`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_confirmEmail`]}</span>
                                                        )}
                                                    </MDBCol>
                                                </>
                                            )}

                                            {/* Government ID Section - Only show if governmentidproof is not 3 (Exclude) */}
                                            {data?.governmentidproof !== 3 && data?.governmentIds && Array.isArray(data.governmentIds) && data.governmentIds.length > 0 && (
                                                <>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>Government ID Type{data?.governmentidproof === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <select
                                                            className='form-select'
                                                            onChange={(e) => {
                                                                const selectedType = e.target.value;
                                                                updateParticipant(index, 'governmentIdType', selectedType);
                                                                updateParticipant(index, 'governmentIdNumber', '');
                                                            }}
                                                            value={participant.governmentIdType || ""}
                                                        >
                                                            <option value="">Select ID Type</option>
                                                            {data.governmentIds.map((govId) => (
                                                                <option key={govId.id} value={govId.name}>
                                                                    {govId.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {error[`p${index}_governmentIdType`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_governmentIdType`]}</span>
                                                        )}
                                                    </MDBCol>

                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>Government ID Number{data?.governmentidproof === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <input
                                                            placeholder='Enter ID number'
                                                            type="text"
                                                            className="w-100 form-control mt-1"
                                                            onChange={(e) => updateParticipant(index, 'governmentIdNumber', e.target.value)}
                                                            value={participant.governmentIdNumber || ""}
                                                            disabled={!participant.governmentIdType && data?.governmentidproof !== 1}
                                                        />
                                                        {error[`p${index}_governmentIdNumber`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_governmentIdNumber`]}</span>
                                                        )}
                                                    </MDBCol>
                                                </>
                                            )}

                                            {data?.address !== 3 && (
                                                <>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>Street/Apartment{data?.address === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <input
                                                            placeholder='Enter street address'
                                                            type="text"
                                                            className="w-100 form-control"
                                                            onChange={(e) => updateParticipant(index, 'street', e.target.value)}
                                                            value={participant.street}
                                                        />
                                                        {error[`p${index}_street`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_street`]}</span>
                                                        )}
                                                    </MDBCol>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>Area{data?.address === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <input
                                                            placeholder='Enter area'
                                                            type="text"
                                                            className="w-100 form-control mt-1"
                                                            onChange={(e) => updateParticipant(index, 'area', e.target.value)}
                                                            value={participant.area}
                                                        />
                                                        {error[`p${index}_area`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_area`]}</span>
                                                        )}
                                                    </MDBCol>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>City{data?.address === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <input
                                                            placeholder='Enter city'
                                                            type="text"
                                                            className="w-100 form-control mt-1"
                                                            onChange={(e) => updateParticipant(index, 'city', e.target.value)}
                                                            value={participant.city}
                                                        />
                                                        {error[`p${index}_city`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_city`]}</span>
                                                        )}
                                                    </MDBCol>
                                                    <MDBCol sm={12} md={4}>
                                                        <div className="tel-numbers mt-2">
                                                            <strong>Country{data?.address === 1 && <span className="text-danger">*</span>}</strong>
                                                        </div>
                                                        <select
                                                            className="form-select w-100 p-1 ps-2"
                                                            value={participant.country}
                                                            onChange={(e) => updateParticipant(index, 'country', e.target.value)}
                                                        >
                                                            <option value="" disabled>Select Country</option>
                                                            {countryOptions.map((country) => (
                                                                <option key={country} value={country}>{country}</option>
                                                            ))}
                                                        </select>
                                                        {error[`p${index}_country`] && (
                                                            <span className="clr-red waiver-error-txt">{error[`p${index}_country`]}</span>
                                                        )}
                                                    </MDBCol>
                                                </>
                                            )}

                                            {data?.pincode !== 3 && (
                                                <MDBCol sm={12} md={4}>
                                                    <div className="tel-numbers mt-2">
                                                        <strong>Pincode{data?.pincode === 1 && <span className="text-danger">*</span>}</strong>
                                                    </div>
                                                    <input
                                                        placeholder='Enter pincode'
                                                        type="text"
                                                        className="w-100 form-control"
                                                        onChange={(e) => updateParticipant(index, 'pincode', e.target.value)}
                                                        value={participant.pincode}
                                                    />
                                                    {error[`p${index}_pincode`] && (
                                                        <span className="clr-red waiver-error-txt">{error[`p${index}_pincode`]}</span>
                                                    )}
                                                </MDBCol>
                                            )}


                                            {formMeta.gymid && PlanInfo?.feature?.uploadlogo !== false && (
                                                <MDBCol sm={12}>
                                                    <div className="mt-4">
                                                        <div className="tel-numbers mb-2">
                                                            <strong>Photo</strong>
                                                        </div>
                                                        <div className="photo-upload-container border rounded p-4 text-center bg-light">
                                                            <UploadMemberImg
                                                                handleUrl={(url) => updateParticipant(index, 'imgurl', url)}
                                                                Gid={formMeta.gymid}
                                                                imageurl={participant.imgurl}
                                                                from={"member"}
                                                                className="w-100"
                                                            />
                                                        </div>
                                                    </div>
                                                </MDBCol>
                                            )}
                                        </MDBRow>

                                        {index < participants.length - 1 && (
                                            <div className="routing-border my-4"></div>
                                        )}
                                    </React.Fragment>
                                ))}

                                <MDBRow>
                                    <MDBCol sm={12}>
                                        <MDBBtn
                                            disableAutoFocus
                                            color="primary"
                                            className="mt-3 w-100 py-3 d-flex align-items-center justify-content-center"
                                            onClick={addParticipant}
                                            style={{
                                                borderWidth: '2px',
                                                fontWeight: '600',
                                                fontSize: '1.1rem',
                                            }}
                                        >
                                            <MDBIcon fas icon="plus" className="me-3" size="lg" />
                                            Add Minor
                                        </MDBBtn>
                                    </MDBCol>
                                </MDBRow>

                                {hasMinor && data.consultingcontact !== 3 && (
                                    <>
                                        <div className="routing-border mt-4 mb-3"></div>
                                        <h6 className="text-primary">Parent/Guardian Details</h6>
                                        <MDBRow>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers w-100 mt-2">
                                                    <strong>First Name{data.consultingcontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <div className="pt-1 w-100">
                                                    <input
                                                        placeholder='Enter first name'
                                                        type="text"
                                                        className="w-100 form-control"
                                                        onChange={(e) => setGuardian(prev => ({ ...prev, consultingadultfirstname: e.target.value }))}
                                                        value={guardian.consultingadultfirstname}
                                                    />
                                                    {error.guardian_fname && (
                                                        <span className="clr-red waiver-error-txt">{error.guardian_fname}</span>
                                                    )}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers w-100 mt-2">
                                                    <strong>Last Name{data.consultingcontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <div className="pt-1 w-100">
                                                    <input
                                                        placeholder='Enter last name'
                                                        type="text"
                                                        className="w-100 form-control"
                                                        onChange={(e) => setGuardian(prev => ({ ...prev, consultingadultlastname: e.target.value }))}
                                                        value={guardian.consultingadultlastname}
                                                    />
                                                    {error.guardian_lname && (
                                                        <span className="clr-red waiver-error-txt">{error.guardian_lname}</span>
                                                    )}
                                                </div>
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Contact Number{data.consultingcontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <div className="form pt-1 w-100">
                                                    <PhoneInput
                                                        className="form-control d-flex"
                                                        defaultCountry="IN"
                                                        placeholder="Enter phone number"
                                                        value={guardian.consultingadultcontact}
                                                        onChange={(value) => setGuardian(prev => ({ ...prev, consultingadultcontact: value }))}
                                                    />
                                                </div>
                                                {error.guardian_contact && (
                                                    <span className="clr-red waiver-error-txt">{error.guardian_contact}</span>
                                                )}
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Relationship{data.consultingcontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <input
                                                    placeholder='e.g. Father, Mother, Guardian'
                                                    type="text"
                                                    className="w-100 form-control"
                                                    onChange={(e) => setGuardian(prev => ({ ...prev, consultingadultrelation: e.target.value }))}
                                                    value={guardian.consultingadultrelation}
                                                />
                                                {error.guardian_relation && (
                                                    <span className="clr-red waiver-error-txt">{error.guardian_relation}</span>
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                    </>
                                )}

                                {data?.emergencycontact !== 3 && (
                                    <>
                                        <div className="routing-border mt-4 mb-3"></div>
                                        <h6 className="text-primary">Emergency Contact</h6>
                                        <MDBRow>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>First Name{data?.emergencycontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <input
                                                    placeholder='Enter first name'
                                                    type="text"
                                                    className="w-100 form-control"
                                                    onChange={(e) => setEmergency(prev => ({ ...prev, emergencyfirstname: e.target.value }))}
                                                    value={emergency.emergencyfirstname}
                                                />
                                                {error.emergencyfirstname && (
                                                    <span className="clr-red waiver-error-txt">{error.emergencyfirstname}</span>
                                                )}
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Last Name{data?.emergencycontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <input
                                                    placeholder='Enter last name'
                                                    type="text"
                                                    className="w-100 form-control"
                                                    onChange={(e) => setEmergency(prev => ({ ...prev, emergencylastname: e.target.value }))}
                                                    value={emergency.emergencylastname}
                                                />
                                                {error.emergencylastname && (
                                                    <span className="clr-red waiver-error-txt">{error.emergencylastname}</span>
                                                )}
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Contact Number{data?.emergencycontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <PhoneInput
                                                    className="form-control d-flex"
                                                    defaultCountry="IN"
                                                    placeholder="Enter phone number"
                                                    value={emergency.emergencycontact}
                                                    onChange={(value) => setEmergency(prev => ({ ...prev, emergencycontact: value }))}
                                                />
                                                {error.emergencycontact && (
                                                    <span className="clr-red waiver-error-txt">{error.emergencycontact}</span>
                                                )}
                                            </MDBCol>
                                            <MDBCol sm={12} md={4}>
                                                <div className="tel-numbers mt-2">
                                                    <strong>Relationship{data?.emergencycontact === 1 && <span className="text-danger">*</span>}</strong>
                                                </div>
                                                <input
                                                    placeholder='e.g. Spouse, Parent, Sibling'
                                                    type="text"
                                                    className="w-100 form-control"
                                                    onChange={(e) => setEmergency(prev => ({ ...prev, emergencyrelation: e.target.value }))}
                                                    value={emergency.emergencyrelation}
                                                />
                                                {error.emergencyrelation && (
                                                    <span className="clr-red waiver-error-txt">{error.emergencyrelation}</span>
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                    </>
                                )}

                                <div className="routing-border mt-4 mb-3"></div>
                                <h6 className="text-primary">Agreement</h6>
                                <div
                                    className='m-0 agreement-text'
                                    dangerouslySetInnerHTML={{
                                        __html: data?.agreement || `Lorem ipsum dolor sit amet, consectetur adipiscing elit...`
                                    }}
                                />

                                {data?.checkboxes && Array.isArray(data.checkboxes) && data.checkboxes.length > 0 && (
                                    <div className="mt-3">
                                        {data.checkboxes.map((checkbox, index) => (
                                            <div key={checkbox.id} className='d-flex mt-2'>
                                                <MDBCheckbox
                                                    name={`checkbox_${checkbox.id}`}
                                                    id={`checkbox_${checkbox.id}`}
                                                    className='mt-1'
                                                    checked={checkboxesState[checkbox.id] || false}
                                                    onChange={() => handleCheckboxToggle(checkbox.id)}
                                                />
                                                <div
                                                    className='m-0 ms-2'
                                                    dangerouslySetInnerHTML={{
                                                        __html: checkbox.text?.replace(/\n/g, '<br />') || ''
                                                    }}
                                                />
                                                {checkbox.required && (
                                                    <span className="text-danger ms-1">*</span>
                                                )}
                                            </div>
                                        ))}
                                        {error.checkboxes && (
                                            <span className="clr-red waiver-error-txt d-block mt-2">{error.checkboxes}</span>
                                        )}
                                    </div>
                                )}

                                <MDBRow className="mt-4">
                                    <MDBCol sm={12} md={6}>
                                        <div className="tel-numbers mb-2">
                                            <strong>Today's Date: </strong>
                                            {formatWaiverDate(new Date().toISOString(), data?.gymInfo?.dateFormat)}
                                        </div>
                                    </MDBCol>
                                    <MDBCol sm={12} md={6}>
                                        <div>
                                            <div className="tel-numbers">
                                                <strong>Participant Signature <span className="text-danger">*</span></strong>
                                            </div>
                                            <div className='square border sigCanvas mb-2 mt-2'>
                                                <SignatureCanvas
                                                    penColor='black'
                                                    ref={sigCanvas}
                                                    minWidth={1}
                                                    maxWidth={2.5}
                                                    velocityFilterWeight={0.7}
                                                    onEnd={handleSignatureChange}
                                                />
                                            </div>
                                            <div className="text-right">
                                                {signatureDone && (
                                                    <MDBBtn className="exclude-pdf btn-secondary" onClick={handleSignatureClear} disableAutoFocus>
                                                        Clear
                                                    </MDBBtn>
                                                )}
                                                {error.signatureDone && (
                                                    <span className="clr-red waiver-error-txt d-block mt-2">{error.signatureDone}</span>
                                                )}
                                            </div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                {merror.length > 0 && (
                                    <div className="border p-3 mt-3 rounded-2 border-danger bg-danger bg-opacity-10">
                                        <p className="m-0">
                                            <MDBIcon color="danger" fas icon="exclamation-triangle" className="me-2" />
                                            Incomplete/wrong data in the below sections:
                                            <ul className="mt-2 mb-0">
                                                {merror.map((item, idx) => (
                                                    <li key={idx}>{item}</li>
                                                ))}
                                            </ul>
                                        </p>
                                    </div>
                                )}

                                <div className="d-flex align-items-center justify-content-center w-100 mt-4">
                                    <MDBBtn
                                        disableAutoFocus
                                        onClick={submitHandler}
                                        disabled={submitDisable || loading}
                                        className="d-flex align-items-center px-4"
                                    >
                                        {loading ? (
                                            <>
                                                <MDBSpinner size="sm" role="status" tag="span" />
                                                <span className="ms-2">Submitting...</span>
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </MDBBtn>
                                </div>
                            </>
                        )}

                        {loading && (
                            <div className="page-loader w-100 h-100">
                                <div className="p-3 bg-light rounded-3 d-flex align-items-center justify-content-center flex-column">
                                    <MDBSpinner className='loading-icon' color="dark" role='status' />
                                    <p className="m-0 pt-2" style={{ fontWeight: 500 }}>Submitting... Please wait.</p>
                                </div>
                            </div>
                        )}
                    </MDBCardBody>
                </MDBCard>
                <div className="text-center d-block text-secondary mt-2">Powered by Zencruz</div>
            </div>

            <MDBAlert
                color={(Error2.includes('internet') || Error2.includes('wrong') || Error2.includes('expired')) ? 'danger' :
                    (Error2.includes('submitted') ? 'success' : 'secondary')}
                autohide
                position='top-right'
                delay={5000}
                appendToBody
                open={Error2 !== ""}
                onClose={() => setError2("")}
            >
                {Error2}
            </MDBAlert>
        </React.Fragment>
    );
}

export default DigitalWaiver;